// extracted by mini-css-extract-plugin
export var play = "youtubePlayer-module--play--w-o38";
export var youtubePlayer = "youtubePlayer-module--youtube-player--3LCG-";
export var ytpButton = "youtubePlayer-module--ytp-button--1PSV7";
export var ytpLargePlayButton = "youtubePlayer-module--ytp-large-play-button--4ouF6";
export var ytpLargePlayButtonBg = "youtubePlayer-module--ytp-large-play-button-bg--17jAZ";